"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_MASK_PLACEHOLDER = void 0;
// Use the unicode "figure space" character for the default placeholder
// character. This char is the width of a single number, which ensures that
// the mask in an empty or partially-filled input is rendered with perfect
// spacing for numeric input, and good-enough spacing for alpha-numeric input
// (which is less common in masks). For example an input with the mask
// "(###)###-####" will render as "(   )   -    " or "(208)59 -    " as the
// user types instead of "()-" or "(208)59-".
var DEFAULT_MASK_PLACEHOLDER = String.fromCharCode(8199);
exports.DEFAULT_MASK_PLACEHOLDER = DEFAULT_MASK_PLACEHOLDER;